import { Lock } from "lucide-react";

export function ComingSoonPage({ title, label }: { title: string; label: string }) {
  return (
    <section className="coming-soon page-slab narrow">
      <div className="coming-soon-box">
        <Lock />
        <span>{label}</span>
        <h1>{title}</h1>
        <p>This part of Floptropica One is locked for now.</p>
      </div>
    </section>
  );
}
